import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsx("svg", Object.assign({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: _jsx("path", {
        d: "M9.54961 17.9996L3.84961 12.2996L5.27461 10.8746L9.54961 15.1496L18.7246 5.97461L20.1496 7.39961L9.54961 17.9996Z",
        fill: "#0C8E77"
      })
    }))
  });
};
export default Component;
